/* eslint-disable react/no-children-prop */
import {Box} from '@mui/material';
import React, {useEffect, useState} from 'react';
import getContentGameOnContentFull from './get-content-game-in-contentfull';
import {GetRouter, handleConvertToLocaleContentful} from '~/utils';
import EStoreProductDetailCompareEditions from '@wearesection/bandai-react-components/organisms/EStoreProductDetailCompareEditions';

type IProps = {
  sku: string;
  dataTranslation: any;
  onShowCompare: (value: boolean) => void;
};

const EStoreProductDetailCompareEditionsOrganisms: React.FC<IProps> = ({
  sku,
  dataTranslation,
  onShowCompare,
}) => {
  const {locale} = GetRouter();
  const [title, setTitle] = useState<string>('');
  const [editionHeaderList, setEditionHeaderList] = useState<any[]>([]);
  const [listEditionContentItem, setListEditionContentItem] = useState<any[]>([]);


  const [labelEarly, setLabelEarly] = useState<string>('');
  const [labelPreOrder, setPreOrder] = useState<string>('');

  useEffect(() => {
    if (Object?.keys(dataTranslation)?.length) {
      if (sku) {
        getContentGameOnContentFull(sku, handleConvertToLocaleContentful(locale as string)).then(
          (res: any) => {
            if (!res?.length) {
              return;
            }
            const contentDetail = res[0];

            const compare = contentDetail?.compareEditionSection || {};
            if (!Object.keys(compare)?.length) {
              return;
            }
            const configuration = compare?.configuration || {};
            setEditionHeaderList(configuration?.compareEdition?.columnHeader || []);
            setTitle(
              configuration?.title ||
                dataTranslation['estore-product-detail-title-compare-edition'] ||
                ''
            );
            const matrixList = configuration?.compareEdition?.matrix || [];
            if (matrixList.length) {
              matrixList.map((item: any) => {
                if (`${item}`.toLowerCase().includes('p')) {
                  setPreOrder(dataTranslation['estore-pre-order-bonus'] || '');
                }
                if (`${item}`.toLowerCase().includes('e')) {
                  setLabelEarly(dataTranslation['estore-early-purchase-bonus'] || '');
                }
              });
            }
            const newEditionContentItem = configuration?.rowHeader?.map(
              (item: any, index: number) => {
                return {
                  ...item,
                  listShowEdition: matrixList[index]?.split(''),
                };
              }
            );
            setListEditionContentItem(newEditionContentItem || []);
          }
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sku, dataTranslation, locale]);

  useEffect(() => {
    onShowCompare(!!listEditionContentItem?.length);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listEditionContentItem]);

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {!!editionHeaderList?.length && !!listEditionContentItem?.length && (
        <EStoreProductDetailCompareEditions
          listEditionContentItem={listEditionContentItem}
          editionHeaderList={editionHeaderList}
          titleCompareEdition={title}
          labelButton={''}
          onClickBuyEdition={e => {
            console.log(e);
          }}
          labelEarlyPurchase={labelEarly}
          labelPreOrder={labelPreOrder}
        />
      )}
    </Box>
  );
};

export default EStoreProductDetailCompareEditionsOrganisms;
